import React from 'react';
import CommissionRateItem from '../../../Domain/CommissionRateItem';
import CommissionRateService from '../../../Services/CommissionRateService';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class CloseCommissionRateWindowDescription extends React.Component {
  static titleForEdit = (editedItem) => `Close Commission Rate (#${editedItem.CommissionRateId})`;
  static itemType = CommissionRateItem;
  static serviceFunction = CommissionRateService.CloseItem;

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'ClosedOn',
          label: 'Closed On',
          className: 'col-12',
          type: InputTypesEnum.Date,
          validityChecker: ValidityHelper.forRequiredDateTodayOrLater,
        },
      ],
    },
  ];
}
